import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";
import AppContext from "../../container/context";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Alunos({ history, location }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [identificadorEscola, setIdentificadorEscola] = useState("");
  const [chaves, setChaves] = useState([]);
  const [open, setOpen] = useState(false);
  const [novoIdentificador, setNovoIdentificador] = useState("");
  const [semCiclo, setSemCiclo] = useState(false);
  const [filtros, setFiltros] = useState(
    mergeParams({ escolaId: 0 }, location)
  );

  useEffect(() => {
    carregarComboEscolas();
    filtros.escolaId > 0 && listarChaves();
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((escolas) => {
      setComboEscolas(escolas);
    });
  };

  const listarChaves = (filtrosEnviar = filtros) => {
    const chaves = [];
    setFiltros(filtrosEnviar);

    api
      .get("escolas/listarCiclos", filtrosEnviar)
      .then((ciclos) => {
        if (ciclos.length === 0) return setSemCiclo(true);

        let identificador = "";
        if (ciclos.length > 0 && ciclos[0].escolaIdentificador) {
          identificador = ciclos[0].escolaIdentificador;
        }

        ciclos.forEach((ciclo) => {
          chaves.push({
            ciclo: ciclo.cicloNome,
            chave: ciclo.escolaIdentificador + ciclo.cicloIdentificador,
          });
        });

        setIdentificadorEscola(identificador);
        setChaves(chaves);
      })
      .catch((err) => {
        notification("error", "Erro ao listar as Chaves de acesso");
      });
  };

  const fEscolas = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtros.escolaId,
      },
    },

    submit: {
      label: "salvar",
      auto: true,
      action: listarChaves,
    },

    urlParams: true,
    history,
    location,
  };

  const camposDados = () => {
    const campos = {};
    if (!identificadorEscola) {
      campos.avisoIdentificador = {
        type: "component",
        value: (
          <div>
            <h3>
              Escola sem identificador. É necessário cadastrar um identificador
              para possibilitar a geração das chaves de acesso.
            </h3>
            <h4>
              O identificador deve ser composto por três dígitos.{" "}
              {identificadorEscola}
            </h4>
            <br />
          </div>
        ),
      };
    }

    if (semCiclo) {
      campos.avisoIdentificador = {
        type: "component",
        value: (
          <div>
            <h3>Escola sem ciclos.</h3>
            <h4>
              É necessário configurar os ciclos adquiridos pela escola para
              obter as chaves de acesso.
            </h4>
            <br />
          </div>
        ),
      };
    }

    if (!semCiclo) {
      campos.identificadorEscola = {
        label: "Identificador da escola",
        type: "text",
        value: identificadorEscola,
      };
    }

    return campos;
  };

  const confirmarAltIdentificador = () => {
    if (novoIdentificador.length !== 3)
      return notification("warning", "O identificador deve ter 3 caracteres.");

    const dados = {
      escolaId: filtros.escolaId,
      identificador: novoIdentificador,
    };

    api
      .post("escolas/atualizarIdentificador", dados)
      .then((res) => {
        setOpen(false);
        notification("success", "Identificador alterado!");
        listarChaves();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Identificador inválido");
          case 2:
            return notification("error", " Identificador já utilizado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const inserirIdentificador = (param) => {
    setIdentificadorEscola(param.identificadorEscola);

    if (param.identificadorEscola.length !== 3)
      return notification("warning", "O identificador deve ter 3 caracteres.");

    const dados = {
      escolaId: filtros.escolaId,
      identificador: param.identificadorEscola,
    };

    api
      .post("escolas/atualizarIdentificador", dados)
      .then((res) => {
        setOpen(false);
        notification("success", "Identificador alterado!");
        listarChaves();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Identificador inválido");
          case 2:
            return notification("error", " Identificador já utilizado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const alterarIdentificador = (param) => {
    setOpen(true);
    setNovoIdentificador(param.identificadorEscola.toUpperCase());
    setIdentificadorEscola(param.identificadorEscola);
  };

  const fIdentificador = {
    form: camposDados(),
    submit: !semCiclo
      ? {
          label: identificadorEscola === "" ? "Salvar" : "Alterar",
          action:
            identificadorEscola === ""
              ? inserirIdentificador
              : alterarIdentificador,
        }
      : undefined,
  };

  const tbChaves = {
    title: "Chaves da escola",
    columns: [
      {
        label: "Ciclo",
        name: "ciclo",
      },
      {
        label: "Chave de acesso",
        name: "chave",
        style: {
          fontSize: 16,
          fontWeight: "bolder",
        },
      },
    ],
    array: chaves,
  };

  return (
    <div>
      <Form formData={fEscolas} />

      {filtros.escolaId > 0 && <Form formData={fIdentificador} />}

      {chaves.length > 0 && identificadorEscola !== "" && (
        <ActionTable structure={tbChaves} />
      )}

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alterar identificador</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Deseja alterar o identificador da escola para ${novoIdentificador}? Não será mais possível utilizar chaves com o identificador ${identificadorEscola}.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={confirmarAltIdentificador}
            className="btn-danger text-white"
          >
            Alterar
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            color="primary"
            className="text-white"
            autoFocus
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
